import { render, staticRenderFns } from "./navbar_heading.vue?vue&type=template&id=b206bad6&scoped=true"
import script from "./navbar_heading.vue?vue&type=script&lang=js"
export * from "./navbar_heading.vue?vue&type=script&lang=js"
import style0 from "./navbar_heading.vue?vue&type=style&index=0&id=b206bad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b206bad6",
  null
  
)

export default component.exports